<div class="container" *ngIf="data">
   <div class="banner" [ngStyle]="{'background-image': 'url(' + backgroundImage + ')'}">
      <div class="banner__content">
        <div class="banner__content__img" *ngIf="data.banner_primary_image">
          <img [src]="data.banner_primary_image.url" alt="maquinas de gelo" />
        </div>
        <div class="banner__content__txt">
          <div class="banner__content__txt__title">
            <h1 [innerHTML]="data.banner_primary_title">Máquinas de Gelo</h1>
          </div>
          <div class="banner__content__txt__desc">
            <h2 [innerHTML]="data.banner_primary_subtitle"></h2>
          </div>
          <a  *ngIf="data.banner_primary_link && data.banner_primary_label" [href]="data.banner_primary_link" class="banner__content__txt__btn">
            {{data.banner_primary_label}}
          </a>
        </div>
      </div>
    </div>
</div>
